import { applyMiddleware, legacy_createStore as createStore, compose } from "redux";
import thunk from 'redux-thunk';
import AllReducers from "./reducers/AllReducers";

const currentTheme = localStorage?.getItem('currentTheme');
const currentView = localStorage?.getItem('currentView');
const isExpanded = localStorage?.getItem('isExpanded');

const initialStates = {
    auth: {
        loggedIn:  false,
        user: {},
        modules: []
    },
    message: {
        toggleMessage: false,
        message: '',
        type: ''
    },
    store: {
        selectedParentStore: null,
        selectedSubStore: null,
        selectedPlanogram: null,
        stores: [],
        shelves: [],
        products: [],
        isSceneUpdated: false,
        unsavedModifications: false,
        recenterMap: false,
        previewVisible: false,
        selectedProduct: null,
        isEdit: false,
        isStoreSceneUpdated: false,
        isFloorEdit: false,
        storeData: null,
        isInfoWindowVisible: false,
        selectedStoreElement: null,
        isDragEnabled: true,
        snapToRuler: true,
        moveElementsWithRuler: false,
        //history: [],
        //historyStep: 0,
        showElements: null,
        isWallDrawEnabled: false,
        floorMapLayerProperties: null,
        storeUpdated: false,
        zones: [],
        selectedZone: null,
        zonesVisibility: {},
        zonesHasChanges: {},
        currentTab: '',
        newZone: null,
        isZoneDrawEnabled: false,
        zoomToElementId: null,
        sideBarIsOpened: true,
    },
    maintenance: {
        selectedShelfType: null,
        shelfTypes: [],
        selectedProduct: null,
        products: []
    },
    project: {
        selectedProject: null,
        projectIsLoading: false,
        sideBarIsOpened: true,
        usdzUploadProgress: null,
        usdzUrl: null,
        regenerateUsdz: false
    },
    confirm: {
        toggleConfirm: false,
        pendingConfirmAction: null,
        message: '',
        param: null
    },
    theme: {
        currentTheme: currentTheme ? currentTheme : 'Light'
    },
    filterView: {
        projectListFilterView: currentView ? currentView : 'TileView',
        projectListFilterOptionsExpanded: isExpanded === 'true' ? isExpanded === 'true' : false,
        projectListFilters: null,
        projectSort: JSON.stringify({'name': null, 'date': null})
    },
    scannedProject: {
        selectedProject: null,
        selectedElement: null
    },
    backgrounds: {
        backgrounds: null
    }
};

const store = createStore(
    AllReducers,
    initialStates,
    compose(
        applyMiddleware(thunk),
        //process.env.REACT_APP_ENVIRONMENT === 'dev' ? window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__({serialize: true}) : f => f
    )
)

export default store;